var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ExpireHeader',{attrs:{"header":"ดูรายละเอียดสินค้า","img_header":_vm.header_image,"link_back":"stock/storage/expirestorage"}}),_c('Expire_details')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }